import type { ActivityCockpitSnapshot } from '@internal/spassu-code-contract';
import {
  adaptCockpitSnapshot,
  type CockpitRailState,
  type CockpitViaSemantics,
  type CockpitViewModel,
} from '@internal/spassu-code-cockpit-ui';
import { createSessionObservabilityView } from '../components/control-plane-management-labels';

const CONTROL_PLANE_SEMANTICS: CockpitViaSemantics = {
  viaLabel: 'Control Plane',
  presentRail: ({ category }) => ({
    label: category,
    state: controlPlaneRailState(category),
  }),
  presentSessionObservability: snapshot => {
    const session = snapshot.sessionObservability;
    if (!session) return null;
    const usage = snapshot.sections.usage.value;
    return createSessionObservabilityView({
      projection: session.projection,
      stale: session.stale,
      skillsMissing: (snapshot.sections.skills.value ?? []).length === 0,
      usageMissing:
        (usage?.inputTokens.value ?? null) === null &&
        (usage?.outputTokens.value ?? null) === null,
    });
  },
};

export function adaptControlPlaneCockpit(
  snapshot: ActivityCockpitSnapshot,
): CockpitViewModel {
  if (snapshot.workPath !== 'control-plane') {
    throw new Error(
      'Control Plane adapter received an incompatible work path.',
    );
  }
  return adaptCockpitSnapshot(snapshot, CONTROL_PLANE_SEMANTICS);
}

function controlPlaneRailState(category: string): CockpitRailState {
  if (category === 'unclassified') return 'void';
  if (category === 'waiting') return 'wait';
  return 'covered';
}
